import React from 'react';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import Checkbox from 'components/Checkbox';
import Radio from 'components/Radio';
import { Content } from './styles';

const NotificationPreferences = ({
  notificationPreferences,
  setNotificationPreferences
}) => {

  const handleNotificationChannelChange = (channel) => {
    let updatedChannels = notificationPreferences.channels || []
    if (updatedChannels.includes(channel)) {
      updatedChannels = updatedChannels.filter(c => c !== channel)
    } else {
      updatedChannels.push(channel)
    }
    setNotificationPreferences((prev) => ({
      ...prev,
      channels: updatedChannels
    }))
  }

  return (
    <Card>
      <CardHeader>
        <div className='type'>NOTIFICATION PREFERENCES</div>
      </CardHeader>
      <Content>
        <div className='title first'>WHEN SHOULD YOU BE NOTIFIED?</div>
        <div className='optionGroup'>
          <Radio 
            label="Always"
            name="choice"
            value="ALWAYS" 
            checked={notificationPreferences.notifyWhen === 'ALWAYS'}
            onChange={(value) => {
              setNotificationPreferences((prev) => ({
                ...prev,
                notifyWhen: value
              }))
            }} 
          />
          <Radio 
            label="Only when I’m signed in"
            name="choice"
            value="ONLY_WHEN_SIGNED_IN" 
            checked={notificationPreferences.notifyWhen === 'ONLY_WHEN_SIGNED_IN'}
            onChange={(value) => {
              setNotificationPreferences((prev) => ({
                ...prev,
                notifyWhen: value
              }))
            }} 
          />
        </div>
        <div className='title'>CHOOSE WHICH ALERT TYPES YOU WANT TO BE NOTIFIED ABOUT.</div>
        <div className='optionGroup'>
          <Checkbox
            checked={notificationPreferences.criticalAlerts}
            onChange={() => {
              setNotificationPreferences((prev) => ({
                ...prev,
                criticalAlerts: !prev.criticalAlerts
              }))
            }}
            title={"Critical alerts"}
          />
          <Checkbox
            checked={notificationPreferences.highPriorityAlerts}
            onChange={() => {
              setNotificationPreferences((prev) => ({
                ...prev,
                highPriorityAlerts: !prev.highPriorityAlerts
              }))
            }}
            title={"High-priority alerts"}
          />
          <Checkbox
            checked={notificationPreferences.mediumPriorityAlerts}
            onChange={() => {
              setNotificationPreferences((prev) => ({
                ...prev,
                mediumPriorityAlerts: !prev.mediumPriorityAlerts
              }))
            }}
            title={"Medium-priority alerts"}
          />
          <Checkbox
            checked={notificationPreferences.lowPriorityAlerts}
            onChange={() => {
              setNotificationPreferences((prev) => ({
                ...prev,
                lowPriorityAlerts: !prev.lowPriorityAlerts
              }))
            }}
            title={"Low-priority alerts"}
          />
        </div>
        <div className='title'>HOW SHOULD YOU BE NOTIFIED?</div>
        <div className='optionGroup'>
          <Checkbox
            checked={notificationPreferences.channels?.includes('PMS_PUSH')}
            onChange={() => handleNotificationChannelChange('PMS_PUSH')}
            title={"Push notifications"}
          />
          <Checkbox
            checked={notificationPreferences.channels?.includes('STAFF_EMAIL')}
            onChange={() => handleNotificationChannelChange('STAFF_EMAIL')}
            title={"Email notifications"}
          />
          <Checkbox
            checked={notificationPreferences.channels?.includes('STAFF_SMS')}
            onChange={() => handleNotificationChannelChange('STAFF_SMS')}
            title={"SMS notifications"}
          />
        </div>
      </Content>
    </Card>
  )
}

export default NotificationPreferences;
